import * as React from 'react';
import {formatAttachmentName} from '../../utils/functions/formatAttachmentName';
import {FileOutlined} from '@ant-design/icons';

interface ConversationMessageAttachmentProps {
  messageContent: string;
  attachment_name: string;
}

export const ConversationMessageAttachment = ({
  messageContent,
  attachment_name,
}: ConversationMessageAttachmentProps) => {
  if (!messageContent) {
    return (
      <li style={{listStyle: 'none'}} className="conversation__message-attachment">
        <FileOutlined style={{marginRight: '0.2em'}} />
        {formatAttachmentName(attachment_name)}
      </li>
    );
  } else {
    return (
      <li style={{listStyle: 'none'}}>
        <FileOutlined style={{marginRight: '0.2em'}} />
        {formatAttachmentName(attachment_name)}
      </li>
    );
  }
};
